import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, " ¿En cuanto tiempo te contactamos? ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Seleccionar un momento", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group", !_ctx.meta.valid ? 'input-error': ''])
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("select", {
      class: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.val) = $event))
    }, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opciones, (p) => {
        return (_openBlock(), _createElementBlock("option", {
          key: p.id,
          value: p.id
        }, _toDisplayString(p.nombre), 9, _hoisted_3))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.val]
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1)
  ], 2))
}